const findAndReplace = (object, value, replacevalue, fields) => {
  if (object) {
    const keys = Object.keys(object);

    keys.forEach(key => {
      if (Object.hasOwnProperty.call(object, key)) {
        if (typeof object[key] === 'object') {
          findAndReplace(object[key], value, replacevalue, fields);
        }
        const colIncludesValue = object.items?.some(item => {
          if (item.templateId !== undefined) {
            return item.templateId === value;
          }
          return false;
        });

        const stylesIncludesValue =
          object.styles?.templateId !== undefined && object.styles?.templateId === value;

        const sectionIncludesValue = object.templateId !== undefined && object.templateId === value;

        if (colIncludesValue) {
          const columnItems = object.items;
          const foundItem = columnItems.find(item => {
            if (item.templateId !== undefined) {
              return item.templateId === value;
            }
            return false;
          });
          const index = columnItems.indexOf(foundItem);

          fields?.forEach(field => {
            columnItems[index][field] = replacevalue[field];
          });

          object.items = columnItems;
        }

        if (stylesIncludesValue) {
          fields?.forEach(field => {
            object.styles[field] = replacevalue[field];
          });
        }

        if (sectionIncludesValue) {
          fields?.forEach(field => {
            object[field] = replacevalue[field];
          });
        }
      }
    });
  }
};

const transformTemplateData = data => {
  const { template } = data;
  const keys = Object.keys(data);

  keys.forEach(key => {
    if (
      key !== 'template' &&
      key !== 'templateName' &&
      key !== 'variation' &&
      key !== '__typename'
    ) {
      const entry = data[key];
      if (entry) {
        if (Array.isArray(entry)) {
          entry?.forEach(item => {
            const fields =
              item.__typename === 'ContentfulRichText'
                ? ['content']
                : item.__typename === 'ContentfulStyles'
                ? [
                    'backgroundColor',
                    'backgroundImage',
                    'customBackgroundMobile',
                    'customBackgroundDesktop',
                  ]
                : Object.keys(item);

            findAndReplace(template, item.templateId, item, fields);
          });
        } else {
          let fields;
          if (entry.__typename === 'ContentfulSection') {
            fields = Object.keys(entry).filter(entryKey => {
              return entryKey !== 'rows';
            });
          } else {
            fields = Object.keys(entry);
          }

          findAndReplace(template, entry.templateId, entry, fields);
        }
      }
    }
  });

  return template;
};

export default transformTemplateData;
